export const sqft_sizes: any = {
    sqfts: [
        '1-250',
        '251-500',
        '501-750',
        '751-1000',
        '1001-1250',
        '1251-1500',
        '1501-1750',
        '1751-2000',
        '2001-2250',
        '2251-2500',
        '2501-2750',
        '2751-3000',
        '3001-3250',
        '3251-3500',
        '3501-3750',
        '3751-4000',
        '4001-4250',
        '4251-4500',
        '4501-4750',
        '4751-5000',
        '5001-5250',
        '5251-5500',
        '5501-5750',
        '5751-6000',
        '6000+'
    ]
};
